var _DFloatPortal;
import Component from "@glimmer/component";
import { isTesting } from "discourse-common/config/environment";
import { setComponentTemplate } from "@ember/component";
import { createTemplateFactory } from "@ember/template-factory";
export default class DFloatPortal extends Component {
  get inline() {
    return this.args.inline ?? isTesting();
  }
}
_DFloatPortal = DFloatPortal;
setComponentTemplate(createTemplateFactory(
/*
  
    {{#if this.inline}}
      {{yield}}
    {{else}}
      {{#in-element @portalOutletElement insertBefore=null}}
        {{yield}}
      {{/in-element}}
    {{/if}}
  
*/
{
  "id": "VLzF7On+",
  "block": "[[[1,\"\\n\"],[41,[30,0,[\"inline\"]],[[[1,\"      \"],[18,2,null],[1,\"\\n\"]],[]],[[[40,[[[1,\"        \"],[18,2,null],[1,\"\\n\"]],[]],\"%cursor:0%\",[28,[31,3],[[30,1]],null],null]],[]]],[1,\"  \"]],[\"@portalOutletElement\",\"&default\"],false,[\"if\",\"yield\",\"in-element\",\"-in-el-null\"]]",
  "moduleName": "/var/www/discourse/app/assets/javascripts/discourse/node_modules/.embroider/rewritten-packages/float-kit.d0433c99/node_modules/float-kit/components/d-float-portal.js",
  "isStrictMode": true
}), _DFloatPortal);